import { inject, Injectable } from '@angular/core';
import { TokenService } from '../service/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedGuard {
  private readonly tokenService = inject(TokenService);

  canActivate() {
    if (!this.tokenService.getToken()) {
      window.location.href = '/login';
      return false;
    }
    return true;
  }
}
